import React from "react";
import { NewControlManager } from "../newControlManager";
import { UserHeaderWrapper } from "../newControlManager/controlWrappers/user/header";

export function UserControl() {
  return (
      <NewControlManager
        content={[]}
        schemas={[]}
        source={[]}
        objectMetadata={{}}
        options={{ modules: { header: UserHeaderWrapper } }}
      />
  )
}



